import React, { useState } from "react";
import { Form, Button, Alert } from "react-bootstrap";
const logo = require("../assets/images/logo.jpg");

function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    // Simple hardcoded check
    if (username === "admin" && password === "admin123") {
      const now = new Date();
      // Add 3 months (90 days)
      const expiry = now.getTime() + 90 * 24 * 60 * 60 * 1000;
      
      const authData = {
        isLoggedIn: true,
        expiry: expiry
      };
      
      localStorage.setItem("temple_auth", JSON.stringify(authData));
      onLogin();
    } else {
      setError("Invalid username or password");
    }
  };

  const handleInputFocus = (e) => {
    setTimeout(() => {
      try {
        e.target.scrollIntoView({ behavior: "smooth", block: "center" });
      } catch (err) {}
    }, 250);
  };

  return (
    <div className="bg-home login-container">
      <div className="login-card p-3 p-sm-4 text-center shadow-lg" style={{ zIndex: 1 }}>
        <img
          src={logo}
          alt="Logo"
          height="68"
          width="68"
          className="login-logo rounded-circle shadow mb-2 border border-3 border-warning"
        />
        <h4 className="login-title fw-bold mb-1" style={{ color: "#0d1b2a" }}>
          ஆலடி ஈஸ்வரர் கோவில்
        </h4>
        <p className="login-subtitle text-muted small mb-3">
          நிர்வாகி உள்நுழைவு (Admin Login)
        </p>

        {error && <Alert variant="danger" className="py-2 small">{error}</Alert>}

        <Form onSubmit={handleLogin}>
          <Form.Group className="login-form-group mb-3 text-start">
            <Form.Label className="small fw-bold text-secondary mb-1">
              Username / பயனர் பெயர்
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onFocus={handleInputFocus}
              required
              autoComplete="username"
              style={{
                padding: "10px 14px",
                borderRadius: "10px",
                fontSize: "16px",
                border: "1.5px solid #ced4da",
              }}
            />
          </Form.Group>
          <Form.Group className="login-form-group mb-3 text-start">
            <Form.Label className="small fw-bold text-secondary mb-1">
              Password / கடவுச்சொல்
            </Form.Label>
            <Form.Control
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onFocus={handleInputFocus}
              required
              autoComplete="current-password"
              style={{
                padding: "10px 14px",
                borderRadius: "10px",
                fontSize: "16px",
                border: "1.5px solid #ced4da",
              }}
            />
          </Form.Group>
          <Button
            variant="warning"
            type="submit"
            className="w-100 fw-bold py-2 shadow-sm"
            style={{
              borderRadius: "10px",
              fontSize: "1rem",
              backgroundColor: "#e0a96d",
              borderColor: "#e0a96d",
              color: "#0d1b2a",
            }}
          >
            உள்நுழைக / Login
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default Login;
